import { Typography, Box, Stack, Link } from "@mui/material";
import { GradientButton } from "./index";
import { AppRoutes } from "../../types/enums";

export const SuccessLinkLoginBlock = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="calc(100vh - 74px)"
    >
      <Stack width="372px" gap="32px">
        <Stack gap={1}>
          <Typography variant="h1" component="h1" textAlign="left">
            You're signed in
          </Typography>
          <Typography
            variant="subtitle1"
            color="#4C545B"
            textAlign="left"
            fontWeight={400}
          >
            You’re now signed in to{" "}
            <span style={{ fontWeight: 500 }}>Buying Committee Radar.</span>{" "}
            Let’s get to work.
          </Typography>
        </Stack>

        <Link href={AppRoutes.CAMPAIGNS}>
          <GradientButton fullWidth>Continue</GradientButton>
        </Link>
      </Stack>
    </Box>
  );
};
